import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal, CircularProgress } from "@mui/material";
import { holdcartStatus } from "../../../../../../config/Services";
import { useSnackbar } from "../../../hooks/SnackbarProvider";
import { eventTracker } from "../../../../../common/event-tracker/eventTracker";
import { eventTrackerConstant } from "../../../../../common/event-tracker/event-tracker-constants";
import "./HoldCartModal.css";

const HoldCartModal = ({
  open,
  onClose,
  cartId,
  cartItems,
  total,
  onViewHeldOrders,
  onHoldSuccess,
}) => {
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const showSnackbar = useSnackbar();
  const retailUserDetails = JSON.parse(localStorage.getItem("retailUserDetails") || "{}");
  const loggedInUser = retailUserDetails?.uidx;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!cartItems || cartItems?.length < 1) {
      showSnackbar("Add products to the cart to hold.", "info");
      return;
    }
    setLoading(true);
    const holdCartPayload = {
      cartId,
      cartStatus: "HOLD",
      comments: null,
      reason: reason || "",
      updatedByUser: loggedInUser,
    };
    holdcartStatus(holdCartPayload)
      .then((res) => {
        showSnackbar("Cart is successfully held", "success");
        const currentStoreMode = localStorage.getItem("storeMode") || "ONLINE";
        localStorage.setItem("cartStoreMode", currentStoreMode);
        const totalItems = cartItems?.reduce(
          (totalQuantity, item) => totalQuantity + item?.quantity,
          0
        );
        const metaData = {
          amount: total,
          cartId: cartId,
          itemsCount: totalItems,
        };
        eventTracker({ metaData, eventType: eventTrackerConstant.CART_HOLD });
        setLoading(false);
        onClose();
        if (onHoldSuccess) onHoldSuccess(res);
      })
      .catch((err) => {
        showSnackbar(err?.response?.data?.message || err?.message, "error");
        setLoading(false);
      });
  };

  const handleViewHeldOrders = () => {
    onClose();
    if (onViewHeldOrders) {
      onViewHeldOrders();
    } else {
      navigate("/products/holdorderpage");
    }
  };

  const modalContent = (
    <div className="hold-cart-backdrop" onClick={onClose}>
      <aside className="hold-cart-aside" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="hold-cart-header">
          <div className="hold-cart-title-container">
            <h1 className="hold-cart-title" data-testid="text-action-drawer-title">
              Hold cart
            </h1>
          </div>
          <div className="hold-cart-close-container">
            <button
              className="hold-cart-close-btn"
              data-testid="button-action-drawer-close"
              onClick={onClose}
              type="button"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-x"
                aria-hidden="true"
              >
                <path d="M18 6 6 18"></path>
                <path d="m6 6 12 12"></path>
              </svg>
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="hold-cart-body">
          <form onSubmit={handleSubmit} className="hold-cart-form-container">
            <div className="hold-cart-field">
              <label
                className="hold-cart-label"
                data-testid="label-hold-cart-reason"
                htmlFor="hold-cart-reason-input"
              >
                Reason for holding
              </label>
              <input
                id="hold-cart-reason-input"
                className="hold-cart-input"
                placeholder="e.g. Customer waiting for friend"
                data-testid="input-hold-cart-reason"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                disabled={loading}
                autoFocus
              />
            </div>

            <div className="hold-cart-actions">
              <button
                type="submit"
                className="hold-cart-submit-btn"
                data-testid="button-hold-current-order"
                disabled={loading}
              >
                {loading ? (
                  <CircularProgress size={20} sx={{ color: "#fff" }} />
                ) : (
                  "Hold Current Order"
                )}
              </button>
              <button
                type="button"
                className="hold-cart-view-btn"
                data-testid="button-view-held-orders"
                onClick={handleViewHeldOrders}
                disabled={loading}
              >
                View Held Orders
              </button>
            </div>
          </form>
        </div>
      </aside>
    </div>
  );

  return (
    <Modal open={open} onClose={onClose} hideBackdrop>
      {modalContent}
    </Modal>
  );
};

export default HoldCartModal;
